import { RoundedCard } from "shared/UI/RoundedCard/RoundedCard";
import { BreathingExercise } from "shared/request/myHealthyAdvantageApi";
import { Circles } from "../Circles/Circles";
import { StructuredText, StructuredTextDocument } from "react-datocms";
import { useTranslation } from "react-i18next";
import { ReactComponent as MinusImage } from "shared/assets/Icons/minus.svg";
import { ReactComponent as PlusImage } from "shared/assets/Icons/plus.svg";
import { useState } from "react";
import Button from "shared/UI/Buttons/Button";
import { IconButton } from "UIPalette/IconButton/IconButton";

export type BreathingExerciseCardProps = {
  exercise: BreathingExercise;
  onStartExercise: (exercise: BreathingExercise, duration: number) => void;
};

export const BreathingExerciseCard = ({ exercise, onStartExercise }: BreathingExerciseCardProps) => {
  const { t } = useTranslation();
  const [duration, setDuration] = useState(3);
  return (
    <RoundedCard className="flex flex-col items-center h-full justify-between text-center gap-4">
      <div className="flex flex-col items-center">
        <Circles baseColour={exercise.animationColour.hex} className="w-20 pb-2" />
        <h2 className="pb-2">{exercise.name}</h2>
      </div>

      <StructuredText data={exercise.textIntro as StructuredTextDocument} />

      <div className="w-full">
        <div className="w-full flex justify-evenly lg:justify-between items-center text-center mt-auto gap-4">
          <IconButton
            ariaLabel={t("breathingExercises.decreaseExerciseDuration")}
            icon={<MinusImage width="24" height="24" />}
            active={duration > 1}
            fgColour="text-white"
            bgColour="bg-navy-blue hover:bg-navy-blue-light"
            handleClick={() => {
              setDuration(Math.max(duration - 1, 1));
            }}
            hasDropShadow={false}
          />
          <span className="whitespace-pre-line">{t("breathingExercises.durationLabel", { duration, count: duration })}</span>
          <IconButton
            ariaLabel={t("breathingExercises.increaseExerciseDuration")}
            icon={<PlusImage width="24" height="24" />}
            active={duration < 30}
            fgColour="text-white"
            bgColour="bg-navy-blue hover:bg-navy-blue-light"
            handleClick={() => {
              setDuration(Math.min(duration + 1, 30));
            }}
            hasDropShadow={false}
          />
        </div>
        <div className="block w-full h-[4rem] items-end flex">
          <Button text={t("breathingExercises.start")} onClick={() => onStartExercise(exercise, duration)} />
        </div>
      </div>
    </RoundedCard>
  );
};
